export default __webpack_public_path__ + "static/tech-vmware-6cd92277e83e665df9258ee46c4e8744.png";